export const todos = [
    { id: "1", name: "Сделать проектную работу" },
    { id: "2", name: "Полить цветы" },
    { id: "3", name: "Пройти туториал по Реакту" },
    { id: "4", name: "Сделать фронт для своего проекта" },
    { id: "5", name: "Погулять с собакой" },
    { id: "6", name: "Разобраться в замыканиях" },
    { id: "7", name: "Решить задачу на Codewars" },
];
